import { styleFn, Styles } from 'react-select/src/styles';

export default function mergeSelectStyles(defaultTheme: Styles, themeStyles: Styles) {
	const styleKeys = [
		...Object.keys(themeStyles),
		...Object.keys(defaultTheme)
	] as (keyof Styles)[];

	return styleKeys.reduce(
		(prevTheme, currentKey) => ({
			...prevTheme,
			[currentKey]: (...params: Parameters<styleFn>) => ({
				...params[0],
				...(defaultTheme[currentKey]
					? (defaultTheme[currentKey] as styleFn)(...params)
					: null),
				...(themeStyles[currentKey]
					? (themeStyles[currentKey] as styleFn)(...params)
					: null)
			})
		}),
		{} as Styles
	);
}
